module.exports = __webpack_public_path__ + "316389afabb5352679fff7f6401c4d59.svg";